export default "__VITE_ASSET__DKQUqeFM__"